{"schemaVersion":1,"release":{"version":"1.1.11","build":173,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.11-173.dmg","sha256":"bce31fef1724fdadd0b093ea5e6706c62b442d512bd928f6e50d866316eaf09b","size":286948312}}
